"use client"
import { Briefcase, House, Tree } from "@phosphor-icons/react";

export default function ProjectTypeIcon(args: { projectType: string, size?: number }) {
  const { projectType, size=20 } = args;
  if (!projectType) {
    return <></>;
  }
  switch (projectType.toLowerCase()) {
    case "residential":
      return (
        <div className="group">
          <House className="mr-2" size={size} />
          <span className="hidden group-hover:block absolute bg-gray-200 text-xs rounded-sm px-2 py-1 -mt-8 -ml-6">
            Residential
          </span>
        </div>
      );
    case "commercial":
        return (
            <div className="group">
              <Briefcase className="mr-2" size={size} />
              <span className="hidden group-hover:block absolute bg-gray-200 text-xs rounded-sm px-2 py-1 -mt-8 -ml-6">
                Commercial
              </span>
            </div>
          );
    case "plotted development":
        return (
            <div className="group">
              <Tree className="mr-2" size={size} />
              <span className="hidden group-hover:block absolute bg-gray-200 text-xs rounded-sm px-2 py-1 -mt-8 -ml-6">
                Plotted development
              </span>
            </div>
          );
    case 'mixed development (residential & commercial)':
        return (
            <div className="group">
              <div className="flex flex-row">
                <House size={size} />
                <Briefcase className="mr-2" size={size} />
              </div>
              <span className="hidden group-hover:block absolute bg-gray-200 text-xs rounded-sm px-2 py-1 -mt-8 -ml-6">
                Mixed development
              </span>
            </div>
          );
    default:
      return <></>;
  }
}
